var _defs, _polygon, _polygon2, _polygon3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManifoldLoveLogo = function SvgManifoldLoveLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.12 70",
    fill: "none",
    stroke: "#9d174d",
    strokeWidth: "3px"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        stroke-miterlimit: 10;\n      }\n      .cls-1,\n      .cls-2 {\n        stroke-linejoin: bevel;\n      }"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.14 26.9 47.51 43.69 37.77 26.9 35.06 22.24 40 13.73 53.17 13.73 54.95 15.87 64.14 26.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.51 43.69 35.06 56.27 22.6 43.69 5.98 26.9 16.95 13.73 30.12 13.73 35.06 22.24 37.77 26.9 47.51 43.69"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.14 26.9 47.51 43.69 37.77 26.9 64.14 26.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.95,
    y1: 13.73,
    x2: 35.06,
    y2: 56.27
  })));
};
export default SvgManifoldLoveLogo;